import {fetchUniversities} from 'src/redux/admin/actions/universities';
import {connect} from 'react-redux';
import UniversityDropdown from './UniversityDropdown';

export default connect(null, {fetchUniversities})(UniversityDropdown);
